import { CrmEndpointModuleConfig } from 'common-module/endpoint';

import { environment } from '~/envs/environment';

export const endpointConfig: CrmEndpointModuleConfig = {
  endpoints: [
    {
      name: 'crm',
      baseUrl: environment.url,
      withCredentials: true,
      httpHeaders: { Authorization: `Basic ${environment.auth}` },
    },
  ],
};
